import {Component, OnInit, Input, ChangeDetectorRef} from '@angular/core';
import {Router, ActivatedRouteSnapshot, ActivatedRoute, NavigationEnd, ResolveStart} from '@angular/router';

import { AuthService } from './auth.service';
import { TokenService } from './auth-token.service';
import { of } from 'rxjs';
import { map, mapTo, filter, switchMap, tap } from 'rxjs/operators';

@Component({
    selector: 'app-auth',
    templateUrl: './auth.component.html',
    styleUrls: ['./auth.component.scss']
})
export class AuthComponent implements OnInit {
    /**
     * the username required for login
     */
    @Input() username: string;

    /**
     * the password for login
     */
    @Input() password: string;

    /**
     * the display message containnig any login errors
     */
    message: string;

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private authService: AuthService,
        private token: TokenService,
        private cdRef: ChangeDetectorRef
    ) { }

    /**
     * on init verify that the user is valid
     */
    ngOnInit() {
        if (!this.hasValidUser()) {
            this.navigateToLogin();
            return;
        }

        if (this.router.url.startsWith('/login')) {
            this.token.signOut();
            window.location.reload();
        } else {
            this.navigateToProjects();
        }
    }

    getQueryParams() {
        const params = {};
        if (window.location.href.indexOf('?') > 0 && window.location.href.indexOf('?') < window.location.href.length) {
            const searchParams = new URLSearchParams(window.location.href.substring(window.location.href.indexOf('?') + 1));
            if (searchParams.get('m')) {
                params['m'] = searchParams.get('m');
            }
            if (searchParams.get('t')) {
                params['t'] = searchParams.get('t');
            }
        }
        return params;
    }

    /**
     * call the token service in order to generate a new token
     */
    login(): void {
        if (this.username && this.password) {
            this.authService.auth(this.username, this.password).subscribe(
                (data) => {
                    this.token.saveToken(data.token);
                    this.router.navigate(['/project', 'list']);
                },
                (error) => { this.message = error.message; }
            );
        } else {
            this.message = 'credentials missing';
        }
    }

    /**
     * call the token service to generate a new token with extended expiry
     */
    refresh(): void {
        if (this.token.expiresWithin(30)) {
            this.authService.refresh().subscribe(
                (data) => { this.token.saveToken(data.token); },
                (error) => { this.message = error.message; }
            );
        }
    }

    /**
     * verify that the user has a token and this token is not expired
     */
    private hasValidUser() {
        return this.hasToken() && !this.isExpired();
    }

    /**
     * verify that the user has a token
     */
    private hasToken() {
        return this.token.hasToken();
    }

    /**
     * verify that the user token is not expired
     */
    private isExpired() {
        return this.token.whoAmI().isTokenExpired();
    }

    /**
     * navigate to the dashboard page
     */
    private navigateToProjects() {
        this.router.navigate(['/project', 'list']);
    }

    /**
     * navigate to the login page
     */

    private navigateToLogin() {
        this.router.navigate(['/login'], {queryParams: this.getQueryParams()});
    }
}
